var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWheelChair = function SvgWheelChair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.802 7.12a1 1 0 1 0-1.947.46l1.42 6.02c.023.1.061.194.111.279a1 1 0 0 0 .99 1.137h5.09l3.026 5.422a1 1 0 0 0 1.747-.974l-3.312-5.935a1 1 0 0 0-.873-.513h-4.862l-.654-2.774h4.87a1 1 0 0 0 0-2h-5.342l-.264-1.121Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.66 13.315a5.512 5.512 0 0 0 .08 4.285 5.531 5.531 0 0 0 10.197-.189.922.922 0 0 1 1.712.683 7.375 7.375 0 1 1-9.695-9.535.922.922 0 0 1 .71 1.7 5.512 5.512 0 0 0-3.004 3.056Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.273 5.25a2.025 2.025 0 1 0 0-4.05 2.025 2.025 0 0 0 0 4.05Z"
  })));
};

export default SvgWheelChair;